/**
 * The MyHome Team pack's billing code. One named constant because the pack is the one place the
 * lineup must know a code: its ZIP slot (GP13) and its RSN membership both key off it.
 */
export const MYHOME_TEAM_CODE = "BOLT-MYHOME-202502";
